import { createSlice } from "@reduxjs/toolkit";

const initialSubjectOutcome = {
  outcome: "",
  explanation: ""
};

const initialSubjectOutcomesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  authorities: null,
  subjectOutcome: initialSubjectOutcome
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const subjectOutcomeSlice = createSlice({
  name: "subjectOutcomes",
  initialState: initialSubjectOutcomesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSubjectOutcomes
    subjectOutcomesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entity, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
      state.course = entity && entity.course;
      state.subject = entity && entity.subject;
    },
    //getSubjectOutcome
    subjectOutcomeFetched: (state, action) => {
      state.actionsLoading = false;      
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.subjectOutcome = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanSubjectOutcomesState
    subjectOutcomesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = [];
      state.subjectOutcome = initialSubjectOutcome;
    }
  }
});